/** Profiles captured under Social/Personal History — hide from Medical History summary. */
export const SOCIAL_PROFILE_NAMES = new Set([
  "Smoking Profile",
  "Drinking Profile",
  "Herbal Use Profile",
  "Drug Use Profile",
  "Sexual Activity Profile",
]);
